<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" id="btnBack" type="button" elevation="0" color="primary" outlined
                                    :to="`/agcs/${$route.params.id}`">Voltar</v-btn>
                            </template>
                            <span>Voltar para Assembleia</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <span class="text-uppercase"> <strong>{{ dataset.data.name }}</strong></span>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="filterSearch()">
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense id="name" label="Nome" v-model="dataset.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-select dense :items="dataset.votingTypes"
                                        label="Votação" v-model="dataset.filter.voting" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="8">
                <v-card class="table-card">
                    <v-card-title class="table-card-title d-flex justify-space-between">Credenciados para Assembleia
                        <div class="icon-container">
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon icon v-on="on" @click="generateCSV()" size="large" class="me-2">
                                        mdi-microsoft-excel
                                    </v-icon>
                                </template>
                                <span>Gerar CSV da votação</span>
                            </v-tooltip>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma lista de nomes foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.accreditation.user.name`]="{ item }">
                                <v-row class="align-center ">
                                    <v-col cols="12">
                                        <span><strong>{{ item.accreditation.user.name.toUpperCase() }}</strong></span>
                                    </v-col>
                                </v-row>
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip :color="getColorByStatus(item.voting ? item.voting.status : 0)" label>
                                    <template v-if="item.voting">
                                        <span :style="{ color: item.voting.status === 3 ? 'black' : 'white' }">
                                            {{ item.voting.status | enum(eventStatus, "id", "name") }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span >Pendente</span>
                                    </template>
                                </v-chip>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon icon v-on="on" @click="actionGeneralMeeting(item.id, 2)" size="large"
                                            color="red" class="me-2">
                                            mdi-close-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Votar NÃO</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon icon v-on="on" @click="actionGeneralMeeting(item.id, 3)" size="large"
                                            color="grey" class="me-2">
                                            mdi-circle-off-outline
                                        </v-icon>
                                    </template>
                                    <span>Votar NULO</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon icon v-on="on" @click="actionGeneralMeeting(item.id, 1)" size="large"
                                            color="green" class="me-2">
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Votar SIM</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="4">
                <v-card class="table-card">
                    <v-card-title class=" d-flex justify-space-between table-card-title ">Estatística

                        <!-- <div class="icon-container">
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon icon v-on="on" @click="statisticSave(dataset.data)" size="large" class="me-2">
                                        mdi-content-save
                                    </v-icon>
                                </template>
                                <span>Salvar estatistica da Assembleia</span>
                            </v-tooltip>
                        </div> -->

                    </v-card-title>
                    <v-card-text>

                        <div class="summary-item">
                            Participante(s): <span class="summary-value">{{ dataList.data.length }}</span>
                            <br>
                        </div>
                        <div class="summary-item">
                            SIM: <span class="summary-value color-yes">{{ yesCount }}</span> <br>
                            Percentual SIM: <span class="summary-value color-yes" >{{ yesPercentage }} %</span>
                        </div>
                        <div class="summary-item">
                            NÃO: <span class="summary-value color-no">{{ noCount }}</span> <br>
                            Percentual NÃO: <span class="summary-value color-no">{{ noPercentage }} %</span>
                        </div>
                        <div class="summary-item">
                            NULO: <span class="summary-value color-null">{{ nullCount }}</span> <br>
                            Percentual NULO: <span class="summary-value color-null">{{ nullPercentage }} %</span>
                        </div>
                        <div class="summary-item">
                            PENDENTE: <span class="summary-value color-pending">{{ pendingCount }}</span> <br>
                            Percentual PENDENTE: <span class="summary-value color-pending">{{ pendingPercentage
                            }} %</span>
                        </div>
                    </v-card-text>

                </v-card>

            </v-col>

        </v-row>

    </v-container>
</template>

<script>

import Vue from "vue";

import votingTypes from "@/common/data/voting-types.data"
import string from "@/common/util/string"

import object from "@/common/util/object"

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph
} from 'tiptap-vuetify'


export default {
    name: "GeneralMeetingVoting",

    data: () => ({

        page: {
            isNew: false,
            title: "",
        },
        menu: false,
        dataset: {
            breadcrumbItems: [],
            date: null,
            data: {},
            clients: [],
            filter: {
                name: "",
                voting: "",
                general_meeting_id: -1
            },
            votingTypes: votingTypes,
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Paragraph,
        ],
        eventStatus: [
            { id: 0, name: "Pendente" },
            { id: 1, name: "SIM" },
            { id: 2, name: "NÃO" },
            { id: 3, name: "NULO" }
        ],
        dataList: {
            headers: [
                { text: "Nome", value: "accreditation.user.name" },
                { text: "Votação", value: "status" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],

            loading: false,
            //count: 11,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
        yesCount: 0,
        noCount: 0,
        nullCount: 0,
        pendingCount: 0,

        yesPercentage: 0,
        noPercentage: 0,
        nullPercentage: 0,
        pendingPercentage: 0,
    }),

    created() {
        this.loadData()
    },

    computed: {
        computedDateFormatted() {
            return this.formatDate(this.dataset.data.date)
        },

        checkedCountComputed() {
            return this.dataList.data.filter(item => item.checked).length;
        },
        uncheckedCountComputed() {
            return this.dataList.data.filter(item => !item.checked).length;
        },
        checkedPercentageComputed() {
            return ((this.checkedCountComputed / this.dataList.data.length) * 100).toFixed(2);
        },
        uncheckedPercentageComputed() {
            return ((this.uncheckedCountComputed / this.dataList.data.length) * 100).toFixed(2);
        },
    },


    methods: {

        pageChanged(page) {            
            this.dataList.options.page = page;
            this.filterSearch();
        },

        pageSizeChanged(size) {    
            this.dataList.options.itemsPerPage = size;
            this.filterSearch(true);
        },

        goBack() {
            this.$router.replace("/agcs");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.loadClients();
            await this.load();
            await this.filterSearch();
            await this.updateSummary();
        },

        setPage() {
            this.page.title = `Votação da Assembleia`;
        },

        formatDate(date) {
            if (!date) return null

            return this.$moment(date).format('DD/MM/YYYY')
        },
        parseDate(date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Início",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "AGC",
                disabled: false,
                to: "/agcs",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: `Votação da Assembleia`,
                disabled: true,
                exact: true,
            });
        },

        updateSummary() {

            const checkedItems = this.dataList.data.filter(item => item.voting && item.voting.status === 1);
            const uncheckedItems = this.dataList.data.filter(item => item.voting && item.voting.status === 2);
            const pendingItems = this.dataList.data.filter(item => !item.voting || item.voting.status === 0);
            const nullItems = this.dataList.data.filter(item => item.voting && item.voting.status === 3);

            this.yesCount = checkedItems.length;
            this.noCount = uncheckedItems.length;
            this.pendingCount = pendingItems.length;
            this.nullCount = nullItems.length;

            this.yesPercentage = (this.yesCount ? ((this.yesCount / this.dataList.data.length) * 100).toFixed(2) : 0 );
            this.noPercentage = (this.noCount ? ((this.noCount / this.dataList.data.length) * 100).toFixed(2) : 0 );
            this.pendingPercentage = (this.pendingCount ? ((this.pendingCount / this.dataList.data.length) * 100).toFixed(2) : 0)
            this.nullPercentage = (this.nullCount ? ((this.nullCount / this.dataList.data.length) * 100).toFixed(2) : 0)

        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                default:
                    break;
            }
        },


        async load() {

            const id = this.$route.params.id;

            try {
                const result = await axios.get(`/api/admin/general-meetings/${id}`);

                const data = result.data.content;

                this.dataset.data = data;
                            
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async filterSearch() {
 
            const id = this.$route.params.id;
            
           let search = Object.fromEntries(Object.entries(this.dataset.filter).filter(([_, v]) => v))

           search = !object.isEmpty(search) ? search : {};
            
            search.general_meeting_id = id

            if(!search.voting && this.dataset.filter.voting === 0) search.voting = 0
            
            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;
         
            try {
                const result = await axios.get('/api/admin/accreditations', { params: { page: this.dataList.options.page, limit: limit, search: search } });
                                                                          
                const resultContent = result.data.content

                this.dataList.data = resultContent.data;

                this.dataList.count = resultContent.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadClients() {

            try {
                const result = await axios.get(`/api/clients`);

                const data = result.data.content;

                this.dataset.clients = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                date: this.dataset.data.date,
                client: this.dataset.data.client_id,
                description: this.dataset.data.description,
            }

            return data;
        },

        async generateCSV() {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja exportar os dados para CSV?',
                title: 'Exportar dados',
                actions: {
                    false: 'Cancelar',
                    true: 'Exportar'
                }
            })

            if (!proceedAction) return;

            const data = this.dataList.data

            if (data.length == 0){
                this.$dialog.notify.error("Sem dados para gerar CSV!", { position: "top-right", timeout: 2000 });

                return;
            }

            const newData = data.map(objeto => ({
                "NOME CREDOR": objeto.accreditation.user.name.toUpperCase(),
                "EMAIL CREDOR": objeto.accreditation.user.email,
                "NOME PROCURADOR": objeto.procurator_name || "N/A",
                "SOLICITADO EM": objeto.created_at,
                "VOTAÇÃO": objeto.voting ? (objeto.voting.status === 1 ? "SIM" :
                    (objeto.voting.status === 2 ? "NÃO" :
                        (objeto.voting.status === 3 ? "NULO" : "PENDENTE")))
                    : "PENDENTE",
            }));

            try {

                const header = Object.keys(newData[0]);
                const csvContent = [header.join(';')];

                newData.forEach(item => {
                    const row = header.map(key => {
                        const value = item[key];
                        return typeof value === 'object' && value !== null ? value.join(';') : value;
                    }).join(';');
                    csvContent.push(row);
                });

                const csv = csvContent.join('\r\n');

                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', this.dataset.data.name + '.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$dialog.notify.info("Arquivo CSV gerado com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async actionGeneralMeeting(id, status) {

            const index = this.dataList.data.findIndex(item => item.id === id);

            const voting = this.dataList.data[index].voting

            !voting ? this.dataList.data[index].voting = { status } : this.dataList.data[index].voting.status = status

            try {

                const response = await axios.post(`/api/admin/general-meetings/voting/${id}`, { status });

                this.$dialog.notify.info("Voto contabilizado com sucesso", { position: "top-right", timeout: 2000 });

            } catch (error) {
                voting ? this.dataList.data[index].voting = voting : null;

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
            this.updateSummary();
        },


    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.list-card {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
}

.summary-item {
    margin-bottom: 8px;
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 4px;  
}

.summary-value {
    font-weight: bold;
}

.color-yes{
   color: green;
}
.color-no{
   color: red;
}

.color-null{
   color: grey;
}

.color-pending{
   color: orange;
}



</style>